"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lonate-ceppino": {
    "2b52e065": [{
      "hkey": "88d924e8",
      "slug": "brugheraccia-cerrine",
      "name": "Brugheraccia-Cerrine",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-brughieraccia": [{
      "hkey": "88d924e8",
      "slug": "brugheraccia-cerrine",
      "name": "Brugheraccia-Cerrine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "546b029c": [{
      "hkey": "f18e622c",
      "slug": "lonate-ceppino",
      "name": "Lonate Ceppino",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-lumaga": [{
      "hkey": "f18e622c",
      "slug": "lonate-ceppino",
      "name": "Lonate Ceppino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5aa87083": [{
      "hkey": "f18e622c",
      "slug": "lonate-ceppino",
      "name": "Lonate Ceppino",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-zerbo": [{
      "hkey": "f18e622c",
      "slug": "lonate-ceppino",
      "name": "Lonate Ceppino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "39263e68": [{
      "hkey": "f18e622c",
      "slug": "lonate-ceppino",
      "name": "Lonate Ceppino",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-zuffolino": [{
      "hkey": "f18e622c",
      "slug": "lonate-ceppino",
      "name": "Lonate Ceppino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0c7909e5": [{
      "hkey": "8bdfbd04",
      "slug": "ceppine",
      "name": "Ceppine",
      "primary": true,
      "skipSearch": false
    }],
    "ceppine-inferiore": [{
      "hkey": "8bdfbd04",
      "slug": "ceppine",
      "name": "Ceppine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c161123e": [{
      "hkey": "f18e622c",
      "slug": "lonate-ceppino",
      "name": "Lonate Ceppino",
      "primary": true,
      "skipSearch": false
    }],
    "madonna": [{
      "hkey": "f18e622c",
      "slug": "lonate-ceppino",
      "name": "Lonate Ceppino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b3c5dca9": [{
      "hkey": "f18e622c",
      "slug": "lonate-ceppino",
      "name": "Lonate Ceppino",
      "primary": true,
      "skipSearch": false
    }],
    "ronco": [{
      "hkey": "f18e622c",
      "slug": "lonate-ceppino",
      "name": "Lonate Ceppino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;